<template>
  <div class="search-block">

      <div class="search-input">
        <h4 v-if="!searchResult" >Поиск заказчика</h4>
        <div class="security-options">
          <input v-model="searchText" class="input border-search" placeholder="ИНН или название компании" />
          <font-awesome-icon @click="search" class="icon border-search" icon="fa-solid fa-magnifying-glass" />
        </div>
      </div>

      <div v-if="searchResult && !notFound" class="search-result small">
        <table class="company-table">
          <thead>
            <tr>
              <th>Название</th>
              <th>ИНН</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in searchResult" :key="row.id" 
            @click="chooseCustomer(row)"
            class="item hover">
              <td>
                  <p>{{ row.name }}</p>
              </td>
              <td>
                  <p>{{ row.inn }}</p>
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="isConfirm" class="confirm-block">
        <h5>Выбрать этого исполнителя?</h5>
        <div class="center">
          <div class="confirn-info">
            <p>{{ selectCustomer.name }}</p>
            <p>{{ selectCustomer.inn }}</p>
          </div>
          <div class="confirm-btn">
            <p class="p-success hover" @click="confirmChoose">Да</p>
            <p class="p-denied hover" @click="reserChoose">Нет</p>
          </div>
        </div>
      </div>
      <div class="search-result" v-if="notFound">
        <p>Не найден</p>
      </div>

  </div>
</template>

<script>
import { ref } from 'vue';
import ApiConnector from '@/backend/apiModels/userApi'
import { buildCustomerSearchPayload } from '@/pages/customer/customerState.mjs'

export default {
  name:'CustomerFormSearch',
  setup(_,{emit}) {    

    const api = new ApiConnector()
    const searchText = ref('')
    const searchResult = ref(null)
    const notFound = ref(false)
    const isConfirm = ref(false)
    const selectCustomer = ref(null)

    const chooseCustomer = cstm =>{
      selectCustomer.value = cstm
      isConfirm.value = true
    }

    const reserChoose = ()=>{
      selectCustomer.value = null
      isConfirm.value = false
    }

    const confirmChoose = () =>{
      if (selectCustomer.value){
        emit('setCustomer',selectCustomer.value.id)
        selectCustomer.value = null
        isConfirm.value = false
      }
    }

    const search = async () =>{
      const form = buildCustomerSearchPayload(searchText.value)
      if (!form) {
        notFound.value = false
        searchResult.value = null
        return
      }
      const link = 'search/customers'
      try {
        const {response,request} = api.post(link,form)
        await request()
        notFound.value = !response.value || response.value.length === 0;
        searchResult.value = notFound.value ? null : response.value;
      } catch {
        notFound.value = true
        searchResult.value = null
      }
    }

    return {
      selectCustomer,
      isConfirm,
      chooseCustomer,
      reserChoose,
      confirmChoose,
      searchText,
      search,
      searchResult,
      notFound,
    };
  },
};
</script>

<style scoped>
.search-block{
  width: 400px;
  text-align: center;
}


.security-options{
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-result{
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.input{
  min-width: 300px;
}

.icon{
  margin-left: 10px;
}


.small{
  font-size: 12px;
}

.company-table {
  border-collapse: collapse;
}

.company-table th,
.company-table td {
  text-align: center;
  padding: 3px;
  border: 1px solid #ccc;
}

.company-table th {
  font-weight: bold;
}

.hover:hover{
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.1);
}

.border-search{
  border: 2px solid #ccc;
  padding: 2px;
  border-radius: 3px;
}


.confirm-block{
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.confirn-info{
  display: flex;
}

.confirn-info p{
  border: 1px solid #ccc;
  padding: 4px;
  margin-left: 2px;
  margin-right: 2px;
  font-size: 12px;
  border-radius: 3px;
}

.confirm-btn{
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-block h5{
  margin-bottom: 10px;
}

.confirm-btn p{
  border-radius: 5px;
  margin-left: 5px;
  width: 50px;
  padding: 3px;
  border: 1px solid #ccc;
}

.p-success{
  background-color: rgba(152,236,131, 1.0);
}

.p-denied{
 background-color: rgba(251,127,139, 1.0); 
}
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
